import * as React from "react";
import styles from "@styles/components/consumer-care/dont-get-your-answer.module.scss";
import SILink from "@components/link/silink";

export default function DidntGetTheAnswerYou() {

    /**
     * This component is for consumer care contain details and contact us page
     */
    return (
        <section className={styles.didnt_get_the_answer_you} >
            <p>didn’t get the answer you were looking for?</p>
            <SILink classes={''} href={'mailto:care@sidr.com'}>contact us</SILink>
            <img src={'/assets/images/decorations/extra/inner_consumer_care_icon.webp'} alt={'consumer care'}/>
        </section>
    )
}
